import { Component,ViewChild } from '@angular/core';
import { Tabs, Events, NavParams } from 'ionic-angular';

import { Categories } from '../categories/categories';
import { Favorite }   from '../favorite/favorite';
import { Account }    from '../account/account';

import { User }    from '../../providers/user/user';
import { IPTV }    from '../../providers/iptv/iptv';
import { Utils }   from '../../providers/utils/utils';
import { Gateway } from '../../providers/gateway/gateway';

declare var VideoPlayerVLC : any;

@Component({
  selector: 'tabsmain',
  templateUrl: 'tabsmain.html'
})
export class TabsMain {

    @ViewChild('myTabs') tabRef: Tabs;

    public index = 0;

    public stream : any = {
        isPlaying : false,
        url : ''
    }

    /*
    *    Tabs views and params
    */
    public tab1Root = Categories;
    public tab2Root = Favorite;
    public tab4Root = Account;

    constructor(
        private events: Events,
        public user: User,
        public IPTV: IPTV,
        public gateway: Gateway,
        public utils: Utils,
        private params: NavParams
    ) {
        if (this.params.data.setIndex) {
            this.index = this.params.data.setIndex;
        }

        let that = this;
        document.addEventListener('resign', (e: any) => {
            this.stop();
        });    

        this.events.subscribe('platform:pause', () => {
            that.stop();
        });

    }

    tabChange(tab) {
        this.events.publish('tab:change', tab);
    }

    play() {

        if (this.stream.isPlaying) return false;

        if (this.IPTV.resolution.name_tech == 'Stream_Off') {
            this.utils.error('Please select a profile');
            return false;
        }

        if (this.IPTV.resolution.name_tech != 'Stream_Off' && !this.gateway.getAirmontGatewayDomain()) {
            this.utils.error('Airmont Gateway has not been discovered yet');
            return false;
        }

        this.stream.url = this.gateway.getAirmontGatewayDomain()+':8081/ag?encoderPort='+this.IPTV.encoder.port_lan;

        this.stream.isPlaying = true;
        
        let that = this;

        VideoPlayerVLC.play(
            that.stream.url,
            done => {
                that.stream.isPlaying = false;
            },
            error => {
                that.stream.isPlaying = false;
            }
        );
    }

    stop() {
        if (!this.stream.isPlaying) return false;
        this.stream.isPlaying = false;
        VideoPlayerVLC.stop();
    }
    
}


// WEBPACK FOOTER //
// ./src/pages/tabsmain/tabsmain.ts